// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"BM-z","inlineTitle":"CM-z","sponsoredAdsWrapper":"DM-z","marketplaceRecosWrapper":"EM-z"};